import ItemListContainer from './components/items/ItemListContainer';
import NavBar from './components/nav/NavBar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ItemDetailContainer from './components/items/ItemDetailContainer';
import Cart from './components/cart/Cart';
import { CartProvider } from './components/context/CartContext';
import { AuthProvider } from './components/context/AuthContext';
import Login from './components/authentication/Login';
import Register from './components/authentication/Register';
import ProtectedRoute from './components/authentication/ProtectedRoute';

function App() {
	return (
		<div className="min-h-screen bg-slate-300 font-body">
			<BrowserRouter>
				<CartProvider>
					<AuthProvider>
						<Routes>
							<Route
								path="/"
								element={
									<ProtectedRoute>
										<NavBar />
										<ItemListContainer greeting="Bienvenido a TecnoClothes," />
									</ProtectedRoute>
								}
							/>
							<Route path="/login" element={<Login />} />
							<Route path="/register" element={<Register />} />
							<Route
								path="/category/:categoryName"
								element={
									<ProtectedRoute>
										<NavBar />
										<ItemListContainer greeting="Categoria" />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/item/:id"
								element={
									<ProtectedRoute>
										<NavBar />
										<ItemDetailContainer />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/cart"
								element={
									<>
										<NavBar />
										<Cart />
									</>
								}
							/>
						</Routes>
					</AuthProvider>
				</CartProvider>
			</BrowserRouter>
		</div>
	);
}

export default App;
